import * as Business   from '../business';
import * as Helpers    from './helpers';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import Booker          from './booker';
import Clio            from './clio';
import FetchFromServer from '../components/fetch_from_server';
import HousecallPro    from './housecall_pro';
import Jobber          from './jobber';
import Lightspeed      from './lightspeed';
import Navbar          from '../components/navbar';
import QuickBooks      from './qbo';
import React           from 'react';
import ServiceFusion   from './service_fusion';
import ServiceMonster  from './servicemonster';


export default connect(
  (state, { businessID, name }) => ({
    name,
    businessID,
    dataSources: Business.getDataSources(state, businessID),
    statuses:    Business.getDataSourcesReadStatus(state, businessID)
  }),
  (dispatch, { businessID, navigateTo }) => ({
    load:         compose(dispatch, Business.readDataSources, () => businessID),
    deleteSource: name => {
      return dispatch(Business.deleteDataSource({ businessID, name }));
    },
    getAuthorizationURL: name => {
      return dispatch(Business.readDataSourceAuthorizationURL({ businessID, name }));
    },
    navigateTo
  })
)(ConfigureDataSourcePage);


export function ConfigureDataSourcePage({ name, businessID, dataSources, statuses, load, deleteSource, getAuthorizationURL, navigateTo }) {
  const title = Helpers.getDisplayName(name) || 'New Data Source';

  async function handleDelete(event) {
    event.preventDefault();

    await deleteSource(name);
    navigateTo('../');
  }

  function handleConnect(integrationName) {
    return async function onConnect(event) {
      event.preventDefault();

      const authorizationURL = await getAuthorizationURL(integrationName);

      window.location.href = authorizationURL;
    };
  }

  const dataSource   = Helpers.getDataSource(dataSources, name);
  const configurable = Helpers.configurable(dataSources);

  return (
    <React.Fragment>
      <Navbar title={title}/>
      <FetchFromServer statuses={statuses} load={load}>
        {dataSource &&  <DataSource
          {...dataSource}
          businessID={businessID}
          onDisconnect={handleDelete}
          handleConnect={handleConnect}/>
        }
        {!dataSource && configurable && <SelectDataSource
          configurable={configurable}
          handleConnect={handleConnect}
          businessID={businessID}/>
        }
      </FetchFromServer>
    </React.Fragment>
  );
}


function DataSource({ name, businessID, status, onDisconnect, handleConnect }) {
  const components = {
    booker:         Booker,
    clio:           Clio,
    jobber:         Jobber,
    housecallPro:   HousecallPro,
    lightspeed:     Lightspeed,
    qbo:            QuickBooks,
    serviceFusion:  ServiceFusion,
    serviceMonster: ServiceMonster
  };
  const Component  = components[name];

  if (Component)
    return <Component status={status} businessID={businessID} onDisconnect={onDisconnect} onConnect={handleConnect(name)}/>;
  else
    return null;
}


class SelectDataSource extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state  = { name: '' };
    this.select = this.select.bind(this);
  }

  select(name) {
    this.setState({ name });
  }

  render() {
    const { businessID, configurable, handleConnect } = this.props;
    const { name }                                    = this.state;

    return (
      <React.Fragment>
        <DataSourceSelector name={name} configurable={configurable} select={this.select}/>
        {name && (
          <DataSource name={name} businessID={businessID} handleConnect={handleConnect}/>
        )}
      </React.Fragment>
    );
  }

}


function DataSourceSelector({ name, configurable, select }) {

  function onChange({ target }) {
    if (target.value)
      select(target.value);
  }

  return (
    <ul className="list block inset">
      <li className="list-group-title">Select Data Source</li>
      <li className="item-content">
        <div className="item-inner">
          <select value={name} onChange={onChange}>
            <option key="" value="">Select ...</option>
            {configurable.map(({ name, displayName }) => ( // eslint-disable-line no-shadow
              <option key={name} value={name}>{displayName}</option>
            ))}
          </select>
        </div>
      </li>
    </ul>
  );
}
